import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { FormMode } from 'app/core/constants/form-mode';

/** Slugs de sistema: no se editan en UPDATE. */
export const SYSTEM_STATUS_SLUGS = new Set([
  'PENDING',
  'REVIEWING',
  'OBSERVED',
  'APPROVED',
  'REJECTED',
  'EXPIRED',
  'MINISTRY_APPROVED',
  'PAID',
  'DRAFT',
  'ACTIVE',
  'INACTIVE',
  'PENDING_ENTITY',
  'PENDING_PAYMENT',
  'PENDING_REIMBURSEMENT'
]);

@Component({
  selector: 'app-status-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './status-form.component.html'
})
export class StatusFormComponent {
  statusForm = input.required<FormGroup>();
  mode = input<FormMode>(FormMode.CREATE);
  formMode = FormMode;

  categories = [
    { value: 'PROCESS', label: 'PROCESS (flujo / solicitudes)' },
    { value: 'ENTITY', label: 'ENTITY (entidades / periodos)' }
  ];

  stylePresets = [
    'border-secondary text-secondary',
    'border-primary text-primary',
    'border-success text-success',
    'border-warning text-warning',
    'border-danger text-danger',
    'border-info text-info'
  ];

  iconPresets = [
    'fas fa-clock',
    'fas fa-check-circle',
    'fas fa-times-circle',
    'fas fa-exclamation-triangle',
    'fas fa-search',
    'fas fa-stamp',
    'fas fa-money-check-alt',
    'fas fa-check-double',
    'fas fa-pencil-alt',
    'fas fa-ban',
    'fas fa-hourglass-end',
    'fas fa-circle'
  ];

  slugLocked = computed(() => {
    if (this.mode() !== FormMode.EDIT) return false;
    const slug = String(this.statusForm().get('slug')?.value || '').toUpperCase();
    return SYSTEM_STATUS_SLUGS.has(slug);
  });

  previewName(): string {
    return this.statusForm().get('name')?.value || 'Vista previa';
  }

  previewStyle(): string {
    return this.statusForm().get('style')?.value || 'border text-muted';
  }

  previewIcon(): string {
    return this.statusForm().get('icon')?.value || 'fas fa-circle';
  }

  applyPreset(preset: string) {
    this.statusForm().get('style')?.setValue(preset);
  }

  applyIcon(icon: string) {
    this.statusForm().get('icon')?.setValue(icon);
  }
}
